import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,_vm._g(_vm._b({attrs:{"type":"text","prefix":_vm.prefixo,"value":_vm.formatar(_vm.valor)},on:{"keyup":function($event){$event.target.value = _vm.validaCaracteres($event)},"blur":function($event){$event.target.value = _vm.removerCasasIrrelevantes($event.target.value)}}},'v-text-field',{..._vm.$attrs, ..._vm.propsVuetify},false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }